import React from 'react';
import { Caption, Body, H } from 'deltoid/core/Blocks/Typography';
import Form from 'deltoid/core/Form';
import PayUIcons from 'deltoid/core/PayUIcons';
import { goToDashboard } from '@utils/menuList';

const EsignSuccess = ({
  downloadUrl,
  name,
  dialogOnClose,
}) => {
  const handleDownload = () => window.open(downloadUrl, '_blank');
  return (
    <div className='d-flex flex-column'>
      <div className="d-flex flex-row">
        <PayUIcons type="cancel" color="dark" size="16px" className='d-flex esign-success-cross-hidden mb-4' />
        <img src={'/assets/images/onboarding/kyc-verified.svg'} className='d-flex w-25 mb-4' draggable={false} />
        <PayUIcons type="cancel" color="dark" size="16px" className='d-flex esign-success-cross-show mb-4' onClick={dialogOnClose} />
      </div>
      <div className='d-flex flex-column pl-3 pr-3'>
        <Body variant='bold' className='align-self-center'>
          Congratulations
        </Body>
        <H level={6} className='align-self-center mb-3 text-center'>
          {name}
        </H>
        <Body className='align-self-center mb-2 text-center'>
          You can now receive limit free settlements in your bank account.{' '}
          A signed copy of agreement has been sent to your registered email id.{' '}
          Alternately you can download the same from here.
        </Body>
        {
          downloadUrl && (
            <Form.Button variant='underlined' className='p-0 align-self-center mb-4' onClick={handleDownload}>
              Download Agreement
            </Form.Button>
          )}
      </div>
      <div className='d-flex flex-column bg-light pt-3 pb-3'>
        <Form.Button className='align-self-center' type='button' onClick={goToDashboard}>
          Go to Dashboard
        </Form.Button>
      </div>
    </div>
  )
};

export default EsignSuccess;
